/* 3OS CART — add-to-cart AJAX pe homepage + MĂSLINA care zboară în coș + drawer „Bonul casei".
   Formularele de pe homepage sunt <form> brute (NU <product-form>), deci le interceptez aici.
   Reguli: fallback = submit nativ (checkout-ul NU se rupe niciodată); gated reduced-motion pt. zbor. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROUTES = window.routes || {};
  var ADD = ROUTES.cart_add_url || '/cart/add';
  var CART = ROUTES.cart_url || '/cart';

  function commerceContract () {
    var node = document.getElementById('tos-commerce-live');
    if (!node) return null;
    try { return JSON.parse(node.textContent || 'null'); } catch (error) { return null; }
  }

  function variantBySku (sku) {
    var contract = commerceContract();
    var variants = contract && Array.isArray(contract.variants) ? contract.variants : [];
    for (var i = 0; i < variants.length; i += 1) if (variants[i].sku === sku) return variants[i];
    return null;
  }

  function formatMinor (minor) {
    var contract = commerceContract();
    var currency = contract && contract.currency ? contract.currency : 'RON';
    try {
      return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: currency, minimumFractionDigits: minor % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(minor / 100);
    } catch (error) { return (minor / 100).toFixed(minor % 100 ? 2 : 0) + ' ' + currency; }
  }

  function drawer () { return document.querySelector('cart-drawer'); }

  function transactionQueue () {
    var queue = window.__THREE_OLIVES_CART_TRANSACTIONS__;
    return queue && typeof queue.enqueue === 'function' ? queue : null;
  }

  function announceError (message) {
    var live = document.getElementById('CartDrawer-CartErrors') || document.querySelector('[data-pd-status]');
    if (live) live.textContent = message;
  }

  function announceCartConfirmed (cart) {
    var live = document.getElementById('CartDrawer-LiveRegionText') || document.querySelector('[data-pd-status][aria-live="polite"]');
    if (!live) return;
    var count = Math.max(0, Number(cart && cart.item_count) || 0);
    live.textContent = count === 1 ? 'Coș actualizat. Un produs în coș.' : 'Coș actualizat. ' + count + ' produse în coș.';
  }

  function post (form) {
    var fd = new FormData(form);
    var cd = drawer();
    if (cd && typeof cd.getSectionsToRender === 'function') {
      fd.append('sections', cd.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    var id = fd.get('id');
    var quantity = Math.max(1, Number(fd.get('quantity')) || 1);
    var queue = transactionQueue();
    if (!queue) return Promise.reject(new Error('cart_transaction_queue_missing'));

    return queue.enqueue(function () {
      return fetch(ADD, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'cart_add_failed');
            return fetch(CART + '.js', { headers: { 'Accept': 'application/json' } }).then(function (cartResponse) {
              if (!cartResponse.ok) throw new Error('cart_confirmation_failed');
              return cartResponse.json().then(function (confirmedCart) {
                payload.confirmedCart = confirmedCart;
                return payload;
              });
            });
          });
        });
    }, { action: 'add', variantId: String(id || ''), quantity: quantity, source: 'legacy-home-form' });
  }

  function handleAdd (form, btn) {
    if (btn) btn.classList.add('is-adding');
    post(form).then(function (res) {
      flyOlive(btn, function () {
        if (!res.confirmedCart) { refreshCount(); return; }
        setCount(res.confirmedCart.item_count);
        updateSticky(res.confirmedCart);
        var cd = drawer();
        if (cd && res.sections && typeof cd.renderContents === 'function') {
          cd.classList.remove('is-empty'); /* Dawn: fără asta, open() caută .drawer__inner-empty (dispărut la 0→1) → trapFocus(null) */
          try {
            /* renderContents deține singur deschiderea drawer-ului și primește
               declanșatorul pentru revenirea corectă a focusului la închidere. */
            cd.renderContents(res, btn);
          } catch (error) {
            if (window.console) console.warn('3OS cart drawer:', error && error.message ? error.message : error);
          }
        }
        announceCartConfirmed(res.confirmedCart);
      });
    }).catch(function (error) {
      /* A network failure after a Shopify write is ambiguous. Never submit the
         same form again: that can duplicate a paid order. Rehydrate instead. */
      announceError('Nu am putut confirma actualizarea coșului. Verifică Bonul casei și reîncearcă.');
      refreshCount();
      if (window.console) console.warn('3OS cart:', error && error.message ? error.message : error);
    }).finally(function () { if (btn) btn.classList.remove('is-adding'); });
  }

  /* Interceptez add-to-cart de pe homepage (S3 + S7) */
  Array.prototype.forEach.call(document.querySelectorAll('.tos-handover__form, .tos-ordertable__form'), function (form) {
    form.addEventListener('submit', function (e) {
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return; /* fără variantă → lasă nativ (oricum e disabled) */
      e.preventDefault();
      handleAdd(form, form.querySelector('button[type="submit"]'));
    });
  });

  /* Upsell din drawer (500 ml → 1 L): buton cu data-tos-add="<variantId>" */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-tos-add]') : null;
    if (!b) return;
    e.preventDefault();
    var vid = b.getAttribute('data-tos-add');
    if (!vid) return;
    var f = document.createElement('form'); f.style.display = 'none';
    f.innerHTML = '<input name="id" value="' + vid + '"><input name="quantity" value="1">';
    document.body.appendChild(f);
    handleAdd(f, b);
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 200);
  });

  /* ===== MĂSLINA care zboară de la buton la coș ===== */
  function flyOlive (fromEl, onLand) {
    var cartEl = document.querySelector('.tos-header__cart-ico') || document.querySelector('.tos-header__cart');
    if (reduce || !fromEl || !cartEl) { if (onLand) onLand(); return; }
    var a = fromEl.getBoundingClientRect(), b = cartEl.getBoundingClientRect();
    var sx = a.left + a.width / 2, sy = a.top + a.height / 2;
    var dx = (b.left + b.width / 2) - sx, dy = (b.top + b.height / 2) - sy;
    var o = document.createElement('span');
    o.className = 'tos-fly-olive';
    o.style.left = sx + 'px'; o.style.top = sy + 'px';
    document.body.appendChild(o);
    var done = false;
    function finish () { if (done) return; done = true; if (o.parentNode) o.parentNode.removeChild(o); thunk(); if (onLand) onLand(); }
    try {
      var anim = o.animate([
        { transform: 'translate(-50%,-50%) scale(1)', opacity: 1, offset: 0 },
        { transform: 'translate(calc(-50% + ' + (dx * 0.5) + 'px), calc(-50% + ' + (dy * 0.5 - 90) + 'px)) scale(1.18)', opacity: 1, offset: 0.5 },
        { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(.35)', opacity: 0.5, offset: 1 }
      ], { duration: 640, easing: 'cubic-bezier(.5,0,.25,1)' });
      anim.onfinish = finish;
    } catch (e) { finish(); return; }
    setTimeout(finish, 900); /* safety net */
  }
  function thunk () {
    var c = document.querySelector('.tos-header__cart'); if (!c) return;
    c.classList.remove('is-thunk'); void c.offsetWidth; c.classList.add('is-thunk');
  }

  /* ===== count în navbar (Dawn `sections:cart-icon-bubble` NU ajunge aici → setez manual) ===== */
  function refreshCount () {
    fetch(CART + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      setCount(cart.item_count);
      updateSticky(cart);
    }).catch(function () {});
  }
  function setCount (n) {
    var link = document.querySelector('.tos-header__cart'); if (!link) return;
    var badge = link.querySelector('.tos-header__cart-count');
    if (n > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'tos-header__cart-count'; link.appendChild(badge); }
      badge.textContent = n;
    } else if (badge && badge.parentNode) { badge.parentNode.removeChild(badge); }
    link.setAttribute('aria-label', 'Coș (' + n + ')');
  }

  /* ===== STICKY „Adaugă 1 L" — apare după S4, stare vie din coș ===== */
  var LIVE_1L = variantBySku('3OS-PIC-1L');
  var LIVE_500 = variantBySku('3OS-PIC-500');
  var V1L = LIVE_1L ? Number(LIVE_1L.id) : 58308802707837;
  var V500 = LIVE_500 ? Number(LIVE_500.id) : 58308802675069;
  var sticky = document.querySelector('[data-tos-stickycta]');
  function updateSticky (cart) {
    if (!sticky) return;
    var eyebrow = sticky.querySelector('[data-sticky-eyebrow]'), lbl = sticky.querySelector('[data-sticky-btn-label]'), btn = sticky.querySelector('[data-sticky-btn]');
    var has1l = false, has500 = false, items = (cart && cart.items) || [];
    items.forEach(function (i) { if (i.variant_id === V1L) has1l = true; if (i.variant_id === V500) has500 = true; });
    if (has1l) { if (eyebrow) eyebrow.textContent = 'Litrul casei e în coș'; if (lbl) lbl.textContent = 'Vezi Bonul casei'; if (btn) { btn.removeAttribute('data-tos-add'); btn.setAttribute('data-sticky-mode', 'cart'); } sticky.setAttribute('data-state', 'in'); }
    else if (has500) { if (eyebrow) eyebrow.textContent = 'Ai 500 ml în coș'; if (lbl) lbl.textContent = 'Treci la 1 L — +' + formatMinor(Math.max(0, Number(LIVE_1L && LIVE_1L.price) - Number(LIVE_500 && LIVE_500.price))); if (btn) { btn.setAttribute('data-tos-add', V1L); btn.removeAttribute('data-sticky-mode'); } sticky.setAttribute('data-state', 'up'); }
    else { if (eyebrow) eyebrow.textContent = 'Recomandarea casei'; if (lbl) lbl.textContent = 'Adaugă 1 L' + (LIVE_1L ? ' — ' + (LIVE_1L.formattedPrice || formatMinor(Number(LIVE_1L.price))) : ''); if (btn) { btn.setAttribute('data-tos-add', V1L); btn.removeAttribute('data-sticky-mode'); } sticky.setAttribute('data-state', 'new'); }
  }
  if (sticky) {
    var sbtn = sticky.querySelector('[data-sticky-btn]');
    if (sbtn) sbtn.addEventListener('click', function (e) {
      if (sbtn.getAttribute('data-sticky-mode') === 'cart') { e.preventDefault(); var cd = drawer(); if (cd && cd.open) cd.open(sbtn); }
      /* altfel: data-tos-add e prins de listener-ul global de sus */
    });
    if ('IntersectionObserver' in window) {
      /* Vizibilitate = STARE (nu toggle-uri pe muchie), ca să meargă și înainte și înapoi, desktop (rail) + mobil:
         apare pe S5/S6; se retrage pe S7 (cardul de comandă E CTA-ul final) și pe S4 (când te întorci). */
      var S4 = document.querySelector('[data-tos-taste], .tos-taste--salad');
      var S5 = document.querySelector('[data-tos-rules], .tos-rules--asset');
      var S6 = document.querySelector('[data-tos-society], .tos-memcard--asset');
      var S7 = document.querySelector('[data-tos-final], .tos-ordertable--asset');
      var ratios = new WeakMap();
      var vis = function (el) { return el ? (ratios.get(el) || 0) : 0; };
      var recompute = function () {
        var show = (vis(S5) >= 0.35 || vis(S6) >= 0.35) && vis(S7) < 0.6 && vis(S4) < 0.6;
        sticky.classList.toggle('is-shown', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) { ratios.set(es[i].target, es[i].isIntersecting ? es[i].intersectionRatio : 0); }
        recompute();
      }, { threshold: [0, 0.2, 0.35, 0.5, 0.6, 0.8] });
      [S4, S5, S6, S7].forEach(function (el) { if (el) io.observe(el); });
    }
    fetch(CART + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(updateSticky).catch(function () {});
  }
})();
